import { ContactInterface, UserRoleInterface } from "./interfaces";

export function convertBase64ToImgString(base64: string): string {
  return 'data:image/png;base64,' + base64;
}

export function generateTitle(
  title: string,
  joinSeparator = ' ',
  upperCase = false
): string {
  if (title) {
    const words = title.split(/(?=[A-Z])/);

    return upperCase
      ? words.join(joinSeparator).toUpperCase()
      : words.join(joinSeparator);
  } else return title;
}

export function cloneData<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}

export const MOMENT_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export function toFormData<T>(formValue: T | any) {
  const formData = new FormData();

  for (const key of Object.keys(formValue)) {
    const value = formValue[key];
    formData.append(key, value);
  }

  return formData;
}

export function toUpperCaseKeysAccountInfo(data: ContactInterface) {
  const transformedRequestUser: { [key: string]: any } = {};
  for (const key of Object.keys(data)) {
    if (key !== 'file') {
      const newKey = key.charAt(0).toUpperCase() + key.slice(1);
      transformedRequestUser[newKey] = data[key as keyof ContactInterface];
    } else {
      transformedRequestUser[key] = data[key];
    }
  }
  return transformedRequestUser;
}

export function toCamelCaseObjectsInArray(data: any): { [key: string]: any } {
  return data.map((item: any) => {
    const transformedData: { [key: string]: any } = {};
    for (const key of Object.keys(item)) {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      transformedData[newKey] = item[key];
    }
    return transformedData;
  });
}

export function toCamelCaseObjects(data: any): { [key: string]: any } {
  const transformedData: { [key: string]: any } = {};
  for (const key of Object.keys(data)) {
    const newKey = key.charAt(0).toLowerCase() + key.slice(1);
    transformedData[newKey] = data[key];
  }
  return transformedData;
}

export function getCurrentRole(
  currentRoleId: string
): undefined | UserRoleInterface {
  if (!localStorage.getItem('roles')) return;
  const roles = JSON.parse(localStorage.getItem('roles') as string);
  return roles.find((role: UserRoleInterface) => role.id === currentRoleId);
}

export function getLastPart(url: string): string {
  const urls = url.split('/').filter((item) => !!item);
  return urls[urls.length - 1];
}

export function removeUnnecesaryKeysFromObject(keys: string[], data: any) {
  const result: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(data)) {
    if (!keys.includes(key)) {
      result[key] = value;
    }
  }
  return result;
}

export function fileToBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
}
export function detectBrowserName() {
  const agent = window.navigator.userAgent.toLowerCase();
  switch (true) {
    case agent.indexOf('edge') > -1:
      return 'edge';
    case agent.indexOf('opr') > -1 && !!(<any>window).opr:
      return 'opera';
    case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
      return 'chrome';
    case agent.indexOf('trident') > -1:
      return 'ie';
    case agent.indexOf('firefox') > -1:
      return 'firefox';
    case agent.indexOf('safari') > -1:
      return 'safari';
    default:
      return 'other';
  }
}
